// extracted by mini-css-extract-plugin
export var quantityInput = "_p1-0";